import React from 'react';
import PropTypes from 'prop-types';
import { InfoIconSmall } from '@domain-group/fe-co-icon';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import BaseDetails from './base-details';
import * as styles from './info-link-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InfoLinkDetails = _ref => {
  var icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    link = _ref.link,
    className = _ref.className;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX(BaseDetails, {
    label: label,
    icon: icon,
    className: className
  }, value, ___EmotionJSX("a", {
    css: styles.icon,
    href: getAbsoluteUrl(link),
    rel: "nofollow",
    "aria-label": "Info"
  }, ___EmotionJSX(InfoIconSmall, null)));
};
InfoLinkDetails.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.func,
  className: PropTypes.string
};
InfoLinkDetails.defaultProps = {
  icon: null,
  className: null
};
export default InfoLinkDetails;